import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { InstagramDirectService } from '../services/instagram-direct.service';

@Component({
  selector: 'app-config-instagram-direct',
  templateUrl: './config-instagram-direct.component.html',
  styleUrls: ['./config-instagram-direct.component.scss']
})
export class ConfigInstagramDirectComponent implements OnInit {

  contaConectada: any = null;
  carregando = false;
  carregandoConexao = false;
  carregandoRenovacao = false;
  carregandoTeste = false;
  erro: string = null;
  sucesso: string = null;
  perfilDados: any = null;

  constructor(
    private instagramDirectService: InstagramDirectService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // Verificar se há código de autorização na URL
    console.log('[InstagramDirect] Iniciando componente');
    console.log('[InstagramDirect] URL atual:', window.location.href);
    console.log('[InstagramDirect] Search params:', window.location.search);

    const urlParams = new URLSearchParams(window.location.search);
    const codigo = urlParams.get('code');
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    console.log('[InstagramDirect] Código encontrado:', codigo);
    console.log('[InstagramDirect] Erro encontrado:', error);
    console.log('[InstagramDirect] Descrição do erro:', errorDescription);

    if (error) {
      this.erro = `Erro na autorização: ${error} - ${errorDescription || 'Erro desconhecido'}`;
      console.error('[InstagramDirect] Erro na autorização:', error, errorDescription);
      return;
    }

    if (codigo) {
      console.log('[InstagramDirect] Processando código de autorização');
      // Processar código de autorização
      this.processarCodigoAutorizacao(codigo);
      // Limpar URL
      window.history.replaceState({}, document.title, window.location.pathname);
    } else {
      console.log('[InstagramDirect] Nenhum código encontrado, verificando conta conectada');
      this.verificarContaConectada();
    }
  }

  /**
   * Verifica se há conta conectada
   */
  verificarContaConectada() {
    this.carregando = true;
    this.erro = null;

    this.instagramDirectService.obtenhaContaConectada().then((resposta: any) => {
      this.contaConectada = resposta;
      this.carregando = false;
      this.cdr.markForCheck();
    }).catch((erro) => {
      this.erro = 'Erro ao verificar conta conectada';
      this.carregando = false;
      console.error('Erro ao verificar conta:', erro);
      this.cdr.markForCheck();
    });
  }

  /**
   * Inicia processo de conexão com Instagram
   */
  conectarInstagram() {
    this.carregandoConexao = true;
    this.erro = null;
    this.sucesso = null;

    this.instagramDirectService.obtenhaUrlAutorizacao().then((resposta: any) => {
      debugger;
      if (resposta && resposta.url) {
        // Redireciona diretamente para a página de autorização do Instagram
        window.location.href = resposta.url;
      } else {
        this.erro = 'Erro ao obter URL de autorização';
        this.carregandoConexao = false;
        this.cdr.markForCheck();
      }
    }).catch((erro) => {
      this.erro = 'Erro ao iniciar processo de conexão';
      this.carregandoConexao = false;
      console.error('Erro ao obter URL:', erro);
      this.cdr.markForCheck();
    });
  }

  /**
   * Processa código de autorização recebido
   */
  processarCodigoAutorizacao(codigo: string) {
    console.log('[InstagramDirect] Iniciando processamento do código');
    console.log('[InstagramDirect] Código recebido:', codigo);
    console.log('[InstagramDirect] Length do código:', codigo?.length);

    if (!codigo) {
      console.error('[InstagramDirect] Código vazio');
      this.erro = 'Código de autorização não recebido';
      this.carregandoConexao = false;
      this.cdr.markForCheck();
      return;
    }

    console.log('[InstagramDirect] Chamando serviço de conexão...');
    this.carregandoConexao = true;
    this.erro = null;
    this.sucesso = null;

    this.instagramDirectService.conectar(codigo).then((resposta: any) => {
      console.log('[InstagramDirect] Resposta do serviço:', resposta);
      this.sucesso = 'Instagram conectado com sucesso!';
      this.carregandoConexao = false;
      this.verificarContaConectada();
      this.cdr.markForCheck();
    }).catch((erro) => {
      console.error('[InstagramDirect] Erro detalhado ao conectar:', erro);
      console.error('[InstagramDirect] Erro message:', erro.message);
      console.error('[InstagramDirect] Erro stack:', erro.stack);

      this.erro = erro.message || 'Erro ao conectar Instagram';
      this.carregandoConexao = false;
      this.cdr.markForCheck();
    });
  }

  /**
   * Desconecta conta Instagram
   */
  desconectar() {
    if (!confirm('Tem certeza que deseja desconectar sua conta do Instagram?')) {
      return;
    }

    this.carregando = true;
    this.erro = null;
    this.sucesso = null;

    this.instagramDirectService.desconectar().then((resposta: any) => {
      this.sucesso = 'Instagram desconectado com sucesso!';
      this.contaConectada = null;
      this.perfilDados = null;
      this.carregando = false;
      this.cdr.markForCheck();
    }).catch((erro) => {
      this.erro = 'Erro ao desconectar conta';
      this.carregando = false;
      console.error('Erro ao desconectar:', erro);
      this.cdr.markForCheck();
    });
  }

  /**
   * Renova token de acesso
   */
  renovarToken() {
    this.carregandoRenovacao = true;
    this.erro = null;
    this.sucesso = null;

    this.instagramDirectService.renovarToken().then((resposta: any) => {
      this.sucesso = 'Token renovado com sucesso!';
      this.carregandoRenovacao = false;
      this.verificarContaConectada(); // Atualiza dados
      this.cdr.markForCheck();
    }).catch((erro) => {
      this.erro = 'Erro ao renovar token';
      this.carregandoRenovacao = false;
      console.error('Erro ao renovar token:', erro);
      this.cdr.markForCheck();
    });
  }

  /**
   * Testa conexão com Instagram
   */
  testarConexao() {
    this.carregandoTeste = true;
    this.erro = null;
    this.sucesso = null;

    this.instagramDirectService.testarConexao().then((resposta: any) => {
      if (resposta && resposta.valido) {
        this.sucesso = 'Conexão testada com sucesso!';
        this.perfilDados = resposta.dados;
      } else {
        this.erro = resposta?.erro || 'Token inválido ou expirado';
      }
      this.carregandoTeste = false;
      this.cdr.markForCheck();
    }).catch((erro) => {
      this.erro = 'Erro ao testar conexão';
      this.carregandoTeste = false;
      console.error('Erro ao testar conexão:', erro);
      this.cdr.markForCheck();
    });
  }

  /**
   * Obtém dados do perfil
   */
  obterPerfilDados() {
    this.instagramDirectService.obtenhaPerfilConectado().then((resposta: any) => {
      this.perfilDados = resposta;
      this.cdr.markForCheck();
    }).catch((erro) => {
      console.error('Erro ao obter perfil:', erro);
    });
  }

  /**
   * Limpa mensagens de erro e sucesso
   */
  limparMensagens() {
    this.erro = null;
    this.sucesso = null;
  }

  /**
   * Verifica se o token está próximo do vencimento
   */
  tokenProximoVencimento(): boolean {
    if (!this.contaConectada?.dataExpiracao) return false;

    const dataExpiracao = new Date(this.contaConectada.dataExpiracao);
    const agora = new Date();
    const setesDias = 7 * 24 * 60 * 60 * 1000; // 7 dias em ms

    return (dataExpiracao.getTime() - agora.getTime()) < setesDias;
  }

  /**
   * Verifica se o token está expirado
   */
  tokenExpirado(): boolean {
    if (!this.contaConectada?.dataExpiracao) return false;

    const dataExpiracao = new Date(this.contaConectada.dataExpiracao);
    const agora = new Date();

    return agora > dataExpiracao;
  }
}
